import { render } from "./App.vue?vue&type=template&id=1d62d8f7&class=bg-gradient-to-r%20from-pink-500%20via-red-500%20to-yellow-500"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1d62d8f7&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__